import { Button, Modal } from '@nike/eds'
import { useGetToleranceConfigQuery } from 'api/app-info'
import { useGetIntFlagQuery } from 'api/feature-toggle'

import { ConfigSection } from './ConfigSection'

interface DcConfigModalProps {
  setShowModal: (showModal: boolean) => void
}

export const DcConfigModal = ({ setShowModal }: DcConfigModalProps) => {
  const { 
    data: toleranceConfig,
    isError: isToleranceConfigError,
    isUninitialized: isToleranceConfigUninitialized,
    isLoading: isToleranceConfigLoading
  } = useGetToleranceConfigQuery()
  const { 
    data: returnWindowDays,
    isError: isReturnWindowDaysError, 
    isUninitialized: isReturnWindowDaysUninitialized, 
    isLoading: isReturnWindowDaysLoading 
  } = useGetIntFlagQuery('validate_digital_return_window_days')

  const modalHeader = <>DC Configuration</>
  const modalFooter = (
      <div><Button onClick={() => { setShowModal(false) }}>Close</Button></div>
  )

  return (
    <>
      <Modal
        className="hidden"
        isOpen={true}
        onDismiss={() => { setShowModal(false) }}
        headerSlot={modalHeader}
        footerSlot={modalFooter}
        hideFade={true}>
        {(isReturnWindowDaysError || isToleranceConfigError) && <div className="p-4 text-red-600">Failed to load DC Config</div>}
        {(isToleranceConfigLoading && isReturnWindowDaysLoading) && <div className="p-4">Loading DC Config...</div>}
        <div className="space-y-5">
          {(toleranceConfig != null && !isToleranceConfigLoading && !isToleranceConfigUninitialized && !isToleranceConfigError) && (
              <ConfigSection
                title="RASN Tolerance Check"
                description="Maximum percentage of units that can be processed above the expected amount"
                isActive={toleranceConfig.enabled}
                value={toleranceConfig.percentageExtraAllowed}
                unit="%"
              />
          )}
          {(returnWindowDays != null && !isReturnWindowDaysLoading && !isReturnWindowDaysUninitialized && !isReturnWindowDaysError) && (
            <ConfigSection
              title="Digital Return Window Warning"
              description="Warns the user if a return is outside of the allowed return window, plus X days"
              isActive={returnWindowDays.enabled}
              value={returnWindowDays.number}
              unit=" days"
            />
          )}
        </div>
      </Modal>
    </>
  )
}
